import src from "IMAGE";
export default { src, width: 1240, height: 57, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AGku3v9CH6j/SCam/0Ymp/9AJKX/QSWl/0MmrP9kNt7/EcARP6P8hLcAAAAASUVORK5CYII="};
